export type ConnectionStatus = "online" | "offline";

const AUTO_HIDE_MS = 6000;

/**
 * Small top-center banner telling the player whether they are in
 * multiplayer or in explicit single-player fallback.
 */
export function showConnectionBanner(status: ConnectionStatus, detail?: string): void {
  document.getElementById("connection-banner")?.remove();

  const banner = document.createElement("div");
  banner.id = "connection-banner";
  const online = status === "online";
  banner.textContent = online
    ? `🟢 Conectado ao servidor${detail ? ` — ${detail}` : ""}`
    : `⚠️ Servidor offline — jogando em modo single-player${detail ? ` (${detail})` : ""}`;
  banner.style.cssText = `
    position: fixed;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    padding: 8px 18px;
    border-radius: 8px;
    background: ${online ? "rgba(20, 60, 30, 0.85)" : "rgba(80, 60, 10, 0.9)"};
    border: 1px solid ${online ? "#4ade80" : "#facc15"};
    color: #fff;
    font-family: 'Segoe UI', system-ui, sans-serif;
    font-size: 0.85rem;
    z-index: 150;
    pointer-events: none;
    transition: opacity 0.5s;
  `;
  document.body.appendChild(banner);

  setTimeout(() => {
    banner.style.opacity = "0";
    setTimeout(() => banner.remove(), 600);
  }, AUTO_HIDE_MS);
}
